var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetManagers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 140,
    viewBox: "0 0 147 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_2541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 147,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 145.5,
    height: 138.5,
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.62 2.62"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.5 139.944L106.75 132.944H46.3749L37.6249 139.944",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.437 38.4443H16.6249V125.944H136.5V107.132",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4999 78.4936C61.4003 79.5498 82.1296 76.9545 93.8437 58.1236C108.486 34.585 111.357 19.8733 144.375 19.1943",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5,
    cy: 92,
    rx: 19.5,
    ry: 20,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2609 99.751V84.4385M19.2609 84.4385L13 89.6885M19.2609 84.4385L25 89.6885",
    stroke: "#FAFAFA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4999 90.0693L52.4999 98.8193",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.62 2.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1249 78.6943L83.1249 98.8193",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.62 2.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.75 63.8193L113.75 98.8193",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.62 2.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.375 44.5693L144.375 98.8193",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.62 2.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetManagers);
export default __webpack_public_path__ + "static/media/asset_managers.2b2ec6e2178ec2a38b30557e719cbf5e.svg";
export { ForwardRef as ReactComponent };